export const reportcustomerconstants = {

    GET_REPORT_CUSTOMER: "GET_REPORT_CUSTOMER_LIST",
    GET_REPORT_CUSTOMER_SUCCESS: "GET_REPORT_CUSTOMER_LIST_SUCCESS",
    GET_REPORT_CUSTOMER_FAILURE: "GET_REPORT_CUSTOMER_LIST_FAILURE",

}